var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"training"},[_c('div',{staticClass:"training__tiles"},_vm._l((_vm.assignments),function(assignment){return _c('training-tile',{key:assignment.id,attrs:{"assignment":assignment}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }